import React from 'react';
import { FormattedMessage } from 'react-intl';

const DigitalBarcodeError = () => (
    <div className="digital-barcode-error">
        <h1>
            <FormattedMessage id="digital.barcode.error" />
        </h1>
    </div>
);

export default DigitalBarcodeError;
